import { TipologiaFascicoloCorrelataVO } from "./tipologia-fascicolo-correlataVO";
import { VoceCorrelataClassificaVO } from "./voce-correlata-classificaVO";
import { StrutturaFascicoloVO } from "./struttura-fascicoloVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";
import { TipoNumerazioneEnum } from "../enum/tipo-numerazione-enum";
import { RepertoriazioneEnum } from "../enum/repertoriazione-enum";
import { AttivitaCorrelataVO } from "./attivitaCorrelataVO";

export class TipologiaIperFascicoloVO {
  id: string;
  codice: string;
  denominazione: string;
  nomeBreve: string;
  tipologieFascicoli: TipologiaFascicoloCorrelataVO[];
  dataAttivazione: string;
  dataCessazione: string;
  classifica: VoceCorrelataClassificaVO;
  attivita: AttivitaCorrelataVO;
  settoriAssociati: StrutturaFascicoloVO[];
  formaNormalizzataOggetto: string;
  campiSpecifici: CampoSpecificoFascicolazioneVO[];
  tipoNumerazione: TipoNumerazioneEnum;
  repertoriazione: RepertoriazioneEnum;
}
